module.exports = __webpack_public_path__ + "img/freespin_feature.8b0ec3de.png";